import {
  Button,
  FileButton,
  Flex,
  Group,
  Paper,
  Text,
  Textarea,
  useMantineTheme,
} from "@mantine/core";
import { ImAttachment } from "react-icons/im";
import { IoSend } from "react-icons/io5";
import React, { FC, useRef, useState } from "react";
import { ChatForm } from "../models/ChatSession";
import { tokenUsername } from "../utilities/TokenUtil";
import FileDropzone from "./FileDropzone";

interface ChatMessageInputProps {
  form: ChatForm;
  sendMessage: () => void;
}

const ChatMessageInput: FC<ChatMessageInputProps> = ({ form, sendMessage }) => {
  const [file, setFile] = useState<File | null>(null);
  const resetRef = useRef<() => void>(null);

  const theme = useMantineTheme();

  const prepareFile = (file: File | null) => {
    setFile(file);
    form.setFieldValue("file", file);
  };

  const clearFile = () => {
    setFile(null);
    resetRef.current?.();
  };

  const handleSubmit = () => {
    sendMessage();
    form.reset();
    clearFile();
  };

  return (
    <>
      <FileDropzone onDrop={prepareFile} />

      <form onSubmit={form.onSubmit(handleSubmit)}>
        {file && (
          <Paper m="lg" p="xs" radius="xl" withBorder>
            <Group justify="space-between">
              <Text size="sm">Attached file: {file.name}</Text>
              <Button
                onClick={clearFile}
                size="compact-xs"
                color={theme.colors.red[8]}
                radius="xl"
              >
                X
              </Button>
            </Group>
          </Paper>
        )}
        {tokenUsername() !== "superuser" && (
          <Flex align="flex-end" gap="md" justify="flex-end" w="50vw" pb="md">
            <Textarea
              key={form.key("message")}
              autosize
              minRows={1}
              maxRows={4}
              placeholder="Message"
              radius="xl"
              styles={{
                root: { flexGrow: 1, display: "block" },
                wrapper: { flexGrow: 1 },
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" && !event.shiftKey) {
                  event.preventDefault();
                  handleSubmit();
                }
              }}
              {...form.getInputProps("message")}
            />
            <FileButton
              onChange={(file) => prepareFile(file)}
              accept="image/png,image/jpeg,application/pdf"
              resetRef={resetRef}
            >
              {(props) => (
                <Button radius="xl" {...props}>
                  <ImAttachment />
                </Button>
              )}
            </FileButton>
            <Button
              disabled={form.getValues().message === "" && file == null}
              type="submit"
              radius="xl"
            >
              <IoSend />
            </Button>
          </Flex>
        )}
      </form>
    </>
  );
};

export default ChatMessageInput;
